import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/**
 * Table Columns =>
 *
 */

const columns = [
  { id: "slno", label: "Sl. No.", minWidth: 170 },
  // { id: 'code', label: 'ISO\u00a0Code', minWidth: 100 },
  {
    id: "account_number",
    label: "Account Number",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "account_balance",
    label: "Account Balance",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
});

export default function MultipleAccountsModal(props) {
  const [open, setOpen] = React.useState(false);
  // const classes = useStyles();
  // const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Getting Accounts Info
  let accounts;
  // let multipleAccountInfo = props.multipleAccountData.map((item, i) => {
  //   // console.log("Multiple Accounts Value: ", item);
  //   // console.log("ACCOUNTS: ", item.accounts);
  //   accounts = item.accounts;
  // });

  return (
    <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open dialog
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Account Balance
        </DialogTitle>
        <Paper>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {/* <TableCell>sl. No</TableCell>
                  <TableCell>Account Number</TableCell>
                  <TableCell>Account Balance</TableCell> */}
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>123456</TableCell>
                  <TableCell>9900</TableCell>
                </TableRow> */}
                {accounts.map((accounts, i) => (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      {accounts.account_number}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {accounts.account_number}
                    </TableCell>
                    <TableCell align="right">
                      ₹{accounts.account_number}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Dialog>
    </div>
  );
}
